<template>
  <div class="wizard-body small-9 columns">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.VOLL360_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.VOLL360_CHANNEL.DESC')"
    />
    <form class="row" @submit.prevent="createChannel()">
      <div class="medium-8 columns">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.domain.$error }">
          {{ $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.DOMAIN.LABEL') }}
          <input
            v-model.trim="domain"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.DOMAIN.PLACEHOLDER')
            "
            @blur="getVollData"
          />
          <span v-if="$v.domain.$error" class="message">{{
            $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.DOMAIN.ERROR')
          }}</span>
        </label>
      </div>

      <div class="medium-8 columns">
        <label :class="{ error: $v.apiKey.$error }">
          {{ $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.API_KEY.LABEL') }}
          <input
            v-model.trim="apiKey"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.API_KEY.PLACEHOLDER')
            "
            @blur="getVollData"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.VOLL360_CHANNEL.API_KEY.SUBTITLE') }}
        </p>
      </div>

      <div class="columns medium-12">
        <button class="header-section back-button" @click.prevent="showCustomFilters = !showCustomFilters">
          Adicionar filtros
          <div class="chevron-icon__wrap">
            <fluent-icon v-if="showCustomFilters" icon="chevron-up" />
            <fluent-icon v-else icon="chevron-down" />
          </div>
        </button>
      </div>

      <div v-if="showCustomFilters" class="columns medium-12">
        <div class="medium-8 columns">
          <label :class="{ error: $v.number.$error }">
            Número
            <input
              v-model.trim="number"
              placeholder="+55DDD900000000"
              type="text"
              @blur="$v.number.$touch"
            />
            <span v-if="$v.number.$error" class="message">
              {{ $t('INBOX_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
            </span>
          </label>
          <p class="help-text">
            Armazenar apenas conversas desse numero.
          </p>
        </div>

        <div class="medium-8 columns">
          <label>
            Campanhas
              <multiselect
                  v-model="campaigns"
                  selectedLabel="Selecionado"
                  placeholder="Selecionar campanhas"
                  label="name"
                  track-by="id"
                  :max-height="160"
                  :option-height="104"
                  :multiple="true"
                  :allow-empty="true"
                  :options="campaignOptions"
                  :disabled="!showCampaigns"
                  :searchable="true"
              >
                  <span slot="noOptions">Nenhuma camapnha encontrada</span>
              </multiselect>
          </label>
          <p class="help-text">
            Considerar armazenar apenas conversas dessas campanhas. Deixe vazio caso queira armazenar todas.
          </p>
        </div>

        <div class="medium-8 columns">
          <label>
            Agentes
              <multiselect
                  v-model="agents"
                  selectedLabel="Selecionado"
                  placeholder="Selecionar agentes"
                  label="name"
                  track-by="id"
                  :max-height="160"
                  :option-height="104"
                  :multiple="true"
                  :allow-empty="true"
                  :options="agentOptions"
                  :disabled="!showAgents"
                  :searchable="true"
              >
                  <span slot="noOptions">Nenhum agente encontrado</span>
              </multiselect>
          </label>
          <p class="help-text">
            Considerar armazenar apenas conversas desses agentes. Deixe vazio caso queira armazenar todos.
          </p>
        </div>

        <div class="medium-8 columns">
          <label>
            Tabulações
            <multiselect
              v-model="tabulations"
              selectedLabel="Selecionado"
              placeholder="Selecionar tabulações"
              label="name"
              track-by="id"
              :max-height="160"
              :option-height="104"
              :multiple="true"
              :allow-empty="true"
              :options="tabulationOptions"
              :disabled="!showTabulation"
              :searchable="true"
            >
              <span slot="noOptions">Nenhuma tabulação encontrada</span>
            </multiselect>
          </label>
          <p class="help-text">
            Considerar armazenar apenas conversas dessas tabulações. Deixe vazio caso queira armazenar todos.
          </p>
        </div>

        <div class="medium-8 columns">
          <label :class="{ error: $v.minMessages.$error }">
            Mínimo de Mensagens
            <input
              v-model.trim="minMessages"
              type="text"
              @blur="$v.minMessages.$touch"
            />
            <span v-if="$v.minMessages.$error" class="message">
              Informe uma quantidade valida
            </span>
          </label>
          <p class="help-text">
            Deve ter essa quantidade mínima de mensagens para poder armazenar as conversas.
          </p>
        </div>
      </div>

      <div class="divider">&nbsp;</div>

      <div class="medium-12 columns">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.VOLL360_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required, url, numeric } from 'vuelidate/lib/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader';
import getUuid from 'widget/helpers/uuid';
import { isPhoneE164OrEmpty } from 'shared/helpers/Validators';
import { watch } from 'vue';

export default {
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      domain: '',
      apiKey: '',
      number: '',
      agents: [],
      tabulations: [],
      campaigns: [],
      agentOptions: [],
      tabulationOptions: [],
      campaignOptions: [],
      minMessages: 10,
      showCustomFilters: false,
      showTabulation: false,
      showAgents: false,
      showCampaigns: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  watch: {
    showCustomFilters() {
      if (!this.showCustomFilters) this.cleanFilters();
    }
  },
  validations: {
    channelName: { required },
    domain: { required, url },
    apiKey: { required },
    number: { isPhoneE164OrEmpty },
    minMessages: { numeric },
  },
  methods: {
    getVollData() {
      this.getTabulationsVoll360();
      this.getAgentsVoll360();
      this.getCampaignsVoll360();
    },
    async getTabulationsVoll360() {
      this.$v.domain.$touch();
      if (this.apiKey && this.domain) {
        try {
          const response = await this.$store.dispatch(
            'inboxes/getVollTabulations',
            {
              domain: this.domain,
              api_key: this.apiKey,
            }
          );

          if (response) {
            this.tabulationOptions = response;
            this.showTabulation = true;
          }
        } catch (error) {
          this.showAlert(
            this.$t('INBOX_MGMT.ADD.VOLL360_CHANNEL.API.ERROR_MESSAGE')
          );
        }
      }
    },
    async getAgentsVoll360() {
      this.$v.domain.$touch();
      if (this.apiKey && this.domain) {
        try {
          const response = await this.$store.dispatch(
            'inboxes/getVollAgents',
            {
              domain: this.domain,
              api_key: this.apiKey,
            }
          );

          if (response) {
            this.agentOptions = response;
            this.showAgents = true;
          }
        } catch (error) {
          this.showAlert(
            this.$t('INBOX_MGMT.ADD.VOLL360_CHANNEL.API.ERROR_MESSAGE')
          );
        }
      }
    },
    async getCampaignsVoll360() {
      this.$v.domain.$touch();
      if (this.apiKey && this.domain) {
        try {
          const response = await this.$store.dispatch(
            'inboxes/getVollCampaigns',
            {
              domain: this.domain,
              api_key: this.apiKey,
            }
          );

          if (response) {
            this.campaignOptions = response;
            this.showCampaigns = true;
          }
        } catch (error) {
          this.showAlert(
            this.$t('INBOX_MGMT.ADD.VOLL360_CHANNEL.API.ERROR_MESSAGE')
          );
        }
      }
    },
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const vollChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.channelName,
            channel: {
              type: 'voll',
              identifier: getUuid(),
              domain: this.domain,
              api_key: this.apiKey,
              custom_config: {
                number: this.number,
                agents: this.agents,
                tabulations: this.tabulations,
                campaigns: this.campaigns,
                min_messages: parseInt(this.minMessages),
              }
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: vollChannel.id,
          },
        });
      } catch (error) {
        this.showAlert(
          this.$t('INBOX_MGMT.ADD.VOLL360_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
    cleanFilters() {
      this.number = '';
      this.agents = [];
      this.agentOptions = [];
      this.minMessages = 10;
    }
  },
};
</script>

<style lang="scss" scoped>
.wizard-body {
  .divider {
    background: #b8b9bb;
    height: 1px;
    margin: 1.5rem 0;
    flex: 0 0 100%;
  }
}
</style>
